import { Fragment, useEffect, useState } from 'react';

import Accordion from './Accordion';
import { Paper } from '@mui/material';
import { useFeatureFlags } from './useFeatureFlags';
import { Box, Checkbox, Drawer, DrawerBody, Grid, GridItem, Typography } from '@coolblue-development/freddy';

const ToolkitPanel = (): JSX.Element => {
  const [experimentDialogOpen, setExperimentDialogOpen] = useState(false);
  const { featureFlags, updateFeatureFlag } = useFeatureFlags();

  useEffect(() => {
    document.addEventListener('keydown', function (event) {
      let keySequence = '';

      if (event.metaKey || event.ctrlKey) {
        keySequence += 'cmd-';
      }

      if (event.shiftKey) {
        keySequence += 'shift-';
      }

      if (event.key !== 'Meta' && event.key !== 'Shift' && event.key !== 'Control' && event.key !== 'Alt') {
        keySequence += event.key.toLowerCase();
      }

      if (keySequence === 'cmd-shift-k' && !experimentDialogOpen) {
        setExperimentDialogOpen(true);
      }
    });
  }, [experimentDialogOpen]);

  const handleClose = (): void => {
    setExperimentDialogOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', gap: '12px' }}>
      <Drawer
        data-testid="close"
        title="Cato Toolkit"
        placement="left"
        open={experimentDialogOpen}
        onClose={handleClose}
        translations={{ ariaLabelClose: 'Close' }}
        body={
          <DrawerBody>
            <Paper
              variant="outlined"
              style={{
                borderRadius: '12px',
                maxHeight: 'calc(100vh - 80px)',
                overflow: 'auto'
              }}
            >
              <Accordion title="Feature flags" accordion={{ defaultExpanded: true }}>
                <Grid gap="200">
                  {featureFlags.map(featureFlag => (
                    <Fragment key={`${featureFlag.name}`}>
                      <GridItem columnEnd="span 1">
                        <Checkbox
                          data-testid={`checkbox-${featureFlag.name}`}
                          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                          onChange={() => updateFeatureFlag(featureFlag.name, !featureFlag.enabled)}
                          checked={featureFlag.enabled}
                        />
                      </GridItem>
                      <GridItem columnEnd="span 11">
                        <Typography fontFamily="DobraSlabMedium">{featureFlag.label}</Typography>
                      </GridItem>
                    </Fragment>
                  ))}
                </Grid>
              </Accordion>
            </Paper>
          </DrawerBody>
        }
      />
    </Box>
  );
};

export default ToolkitPanel;
